module.exports = __webpack_public_path__ + "img/product-preview-55.bf1add9.png";